import { KatAlert } from '@amzn/katal-react';
import React, { useContext } from 'react';
import { CreateCaseConstants } from 'src/constants/ProjectConstants';
import { TranslationContext } from 'src/state/providers/TranslationProvider';

function NotAuthorized() {
  const { messageBundle } = useContext(TranslationContext);
  return (
    <KatAlert
      data-testid="notAuthorizedAlert"
      header={messageBundle.getMessage(CreateCaseConstants.NOT_AUTHORIZED)}
      persistent
      variant="danger"
    ></KatAlert>
  );
}

export default NotAuthorized;
